import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveWaves } from '../../wave/thunks/save-waves.thunk';
import { CustomButton } from './CustomButton';
import { delineationToSaveSelector } from '../../delineation/selectors/delineation.selectors';
import { SAVE_DELINEATION } from '../../analytics/analytics.constants';
import { trackEachSaveButton } from '../../analytics/thunks/trackEachSaveButton.thunk';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { needToAssessSelector } from '../../autoLabels/selectors/auto-labels.selectors';
import { displayAutoLabelsToAssess } from '../../autoLabels/thunks/display-auto-labels-to-assess.thunk';
import * as autoLabelsActions from '../../autoLabels/actions/auto-labels.actions';

export const SaveDelineation: React.FC = () => {
  const dispatch = useDispatch();
  const withSuggestionsPanel = useSelector(
    getLayoutValueSelector('withSuggestionsPanel'),
  );
  const isForbidToSave = useSelector(needToAssessSelector);
  const changed = useSelector(delineationToSaveSelector);

  const saveDelineation = async () => {
    dispatch(trackEachSaveButton(SAVE_DELINEATION));
    if (withSuggestionsPanel) {
      const needToAssessLabels = dispatch(
        displayAutoLabelsToAssess(),
      ) as unknown as boolean;
      if (needToAssessLabels) return;
    }
    await dispatch(saveWaves());
    dispatch(
      autoLabelsActions.setAssessmentStatus({
        status: 'none',
        meta: { history: false },
      }),
    );
  };

  return (
    <CustomButton
      dataTestId='save-delin-btn'
      disabled={!changed || isForbidToSave}
      onClick={saveDelineation}
    >
      Save delineation
    </CustomButton>
  );
};
